import React, { useEffect, useState } from "react";
import { Avatar, Col, Dropdown, Image, Layout, Menu, Modal, Row, Space, Select } from "antd";
import { BrowserRouter as Router, Redirect } from "react-router-dom";
import {
  CaretDownOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  UserOutlined,
  SnippetsFilled,
  ProfileFilled,
  TeamOutlined,
  DashboardFilled,
  FolderOutlined,
  SolutionOutlined,
  SettingFilled,
} from "@ant-design/icons";
import { UserRole } from "../common-auth";
import logo from "./images/ddebt_logo.770c74362dd43d7f83df.png";
import { MainMenu, MainMenuItem } from "./components/MainMenu";
import { MainRoute, MenuItem } from "./MainRoute";
import { OverviewDashboard } from "../screens/dashboard/OverviewDashboard";
import { loadAppConfig } from "../config/app-config";
import { OverviewSettingModal } from "./components/OverviewSettingModal";
import { TeamManagement } from "../screens/teamManagement/TeamManagement";
import { DebtManagement } from "../screens/debtManagement/DebtManagement";
import { useId24 } from "../drivers/id24/Id24-provider";
import { DatamanagementRoute } from "../screens/datamanagement/DataManagementRoute";
import Box from "./styles/Box";
import { BatchProcessDailyFile } from "../screens/batchProcessDailyFile/BatchProcessDailyFile";
import { BatchProcessFile } from "../screens/batchProcessFile/BatchProcessFile";

const { Header, Sider, Content, Footer } = Layout;

interface UserFix {
  employeeId: string;
  email: string;
  name: string;
  groups: string[];
  roles: string[];
  positionName?: string;
  groupName1?: string;
  groupName2?: string;
  groupName3?: string;
  createdAt: string;
  updatedAt: string;
  is_active: boolean;
}
export const MainLayout: React.FC = (): React.ReactElement => {
  function getCookie(key: string) {
    var b = document.cookie.match("(^|;)\\s*" + key + "\\s*=\\s*([^;]+)");
    return b ? b.pop() : "";
  }
  const { Option } = Select;
  const appConfig = loadAppConfig();
  const { tokenAccess, login, logout, id24Axios } = useId24();
  const [roles, setRoles] = useState<any>([]);

  const hasRole = (userRoles: UserRole[]): boolean => {
    const inputRoles = new Set(userRoles);
    const union = new Set(roles.filter((role: any) => inputRoles.has(role)));
    return union.size > 0;
  };
  const [sub, setSub] = useState<string | any>("");

  useEffect(() => {
    (async () => {
      let datacon: any = [];
      if (tokenAccess) {
        await tokenAccess.userAccess.map((groupId) => {
          groupId.roles.forEach(function (value, i) {
            datacon.push(value);
          });
        });
      }
      const uniqueNames = datacon.filter((val: any, id: any, array: any) => {
        return array.indexOf(val) == id;
      });
      setRoles(uniqueNames);
      // Update
    })();
  }, []);

  //Update
  const menuItems: MenuItem[] = [
    // link to dashboard
    {
      label: "",
      icon: <DashboardFilled />,
      path: "/",
      exact: true,
      showInMenu: false,
      target: "/",
      roles: [UserRole.ddebtDashboard],
      component: <Redirect to="/dashboard" />,
    },
    {
      label: "Dashboard",
      icon: <DashboardFilled />,
      path: "/dashboard",
      showInMenu: true,
      target: "/dashboard",
      roles: [UserRole.ddebtDashboard],
      component: <OverviewDashboard baseUrl={"/dashboard"} />,
    },
    {
      label: "Team Management",
      icon: <TeamOutlined />,
      path: "/teamManagement",
      showInMenu: true,
      target: "/teamManagement",
      roles: [UserRole.ddebtTeamManagement],
      component: <TeamManagement userId={"1"} accessRole={roles} />,
    },
    {
      label: "Data Management",
      icon: <ProfileFilled />,
      path: "/datamanagement",
      showInMenu: true,
      target: "/datamanagement",
      roles: [UserRole.ddebtDataManagement],
      component: <DatamanagementRoute baseUrl={"/datamanagement"} accessRole={roles} />,
    },
    {
      label: "Debt Management",
      icon: <SnippetsFilled />,
      path: "/debtmanagement",
      showInMenu: true,
      target: "/debtmanagement",
      roles: [UserRole.ddebtDebtManagementDebt],
      component: <DebtManagement userId={"1"} baseURL={"/debtmanagement"} accessRole={roles} />,
    },
    {
      label: "Setting",
      icon: <SettingFilled />,
      path: "/setting",
      showInMenu: true,
      target: "/setting",
      roles: [UserRole.ddebtSetting],
      component: <BatchProcessDailyFile accessRole={roles} userId={"1"} />,
      subMenu: [
        {
          key: "8",
          label: "Daily Process",
          icon: <SolutionOutlined />,
          path: "/batchProcessDaily",
          showInMenu: true,
          target: "/batchProcessDaily",
          roles: [UserRole.ddebtSettingBatchProcessDaily],
          component: <BatchProcessDailyFile accessRole={roles} userId={"1"} />,
        },

        {
          key: "9",
          label: "File Process",
          icon: <FolderOutlined />,
          path: "/batchProcessFile",
          showInMenu: true,
          target: "/batchProcessFile",
          roles: [UserRole.ddebtSettingBatchProcessFile],
          component: <BatchProcessFile userId={"1"} accessRole={roles} />,
        },
      ].filter((menu) => hasRole(menu.roles)),
    },
  ].filter((menu) => hasRole(menu.roles));
  const [collapse, setCollapse] = React.useState(false);

  const toggleCollapsed = () => {
    setCollapse(!collapse);
  };
  const onClick = async ({ key }: any) => {
    switch (key) {
      case "logout":
        const dIf = new Date();
        dIf.setTime(dIf.getTime() + -1 * 24 * 60 * 60 * 1000);
        document.cookie = "id24Token=0;expires=" + dIf.toUTCString() + ";path=/";
        document.cookie = "refresh-token=0;expires=" + dIf.toUTCString() + ";path=/";
        document.cookie = "autoTimeOut=0;expires=" + dIf.toUTCString() + ";path=/";
        logout().then(() => {
          login(window.location.origin + "/");
        });
        break;
      default:
    }
  };
  const [isModalVisibleResetPassword, setIsModalVisibleResetPassword] = useState(false);
  const [isModalVisibleProfile, setIsModalVisibleProfile] = useState(false);
  const [isModalVisibleOverviewSetting, setIsModalVisibleOverviewSetting] = useState(false);

  const handleOkResetPassword = () => {
    setIsModalVisibleResetPassword(false);
  };

  const handleCancelResetPassword = () => {
    setIsModalVisibleResetPassword(false);
  };

  const showModalProfile = () => {
    setIsModalVisibleProfile(true);
  };

  const handleOkProfile = () => {
    setIsModalVisibleProfile(false);
  };

  const handleCancelProfile = () => {
    setIsModalVisibleProfile(false);
  };

  const createMainMenuItem = (subMenu: MenuItem): MainMenuItem => ({
    label: subMenu.label,
    icon: subMenu.icon,
    path: subMenu.path,
  });

  const menu = (
    <Menu onClick={onClick}>
      <Menu.Item key="profile" onClick={showModalProfile}>
        {`Profile`}
      </Menu.Item>
      <Menu.Item key="logout">{`Logout`}</Menu.Item>
    </Menu>
  );
  const [alias, setAlias] = React.useState<any>({
    name: "unknown",
    empId: "unknown",
    group: "unknown",
    email: "unknown",
  });

  useEffect(() => {
    const groupNameList: any[] = [];
    if (tokenAccess) {
      tokenAccess.userAccess.map((group: any) => {
        groupNameList.push(group.groupName);
      });
    }
    let headerConfig = {
      headers: { Authorization: `ee670412-bb71-4c7a-b928-9158c5d2176d` },
    };
    const fetchData = async () => {
      const userProfile = id24Axios(appConfig.apiBaseUrlDebt);
      const profile = await userProfile.get("/debtor/userDetails");
      const dataResult = profile.data.result;
      setAlias({
        name: dataResult.name,
        email: dataResult.email,
        empId: dataResult.id,
        group: String(groupNameList),
      });
    };
    fetchData().catch(console.error);
  }, []);

  const handleMouseMove = (event: any) => {
    let processSessionTimeout: string | undefined = getCookie("processSessionTimeout");
    if (!processSessionTimeout) {
      processSessionTimeout = "5";
    }
    let conProcessSessionTimeout = Number(processSessionTimeout) - 1;
    const dIf = new Date();
    dIf.setTime(dIf.getTime() + +conProcessSessionTimeout * 60 * 1000);
    document.cookie = "autoTimeOut=" + dIf.toUTCString() + ";expires=" + dIf.toUTCString() + ";path=/";
  };
  return (
    <>
      <Box>
        <div className="mouseArea" onKeyPress={handleMouseMove} onMouseMove={handleMouseMove}>
          <OverviewSettingModal isVisible={isModalVisibleOverviewSetting} handleCancel={() => setIsModalVisibleOverviewSetting(false)} />
          <Router>
            <Modal title="Profile" open={isModalVisibleProfile} onOk={handleOkProfile} onCancel={handleCancelProfile} footer={false}>
              <Row>
                <Col span={24}>Full Name : {alias.name ? alias?.name : "-"}</Col>
                <Col span={24}>Email : {alias?.email ? alias?.email : "-"}</Col>
                <Col span={24}>Roles : {alias?.group ? alias?.group : "-"}</Col>
              </Row>
            </Modal>
            <Modal title="Reset password" open={isModalVisibleResetPassword} onOk={handleOkResetPassword} onCancel={handleCancelResetPassword}>
              <p>Reset your password</p>
            </Modal>
            <Layout>
              <Sider className="site-layout-background" trigger={null} collapsible collapsed={collapse} style={{ backgroundColor: "white" }}>
                <Row className="logo">
                  <Col span={24} style={{ textAlign: "center" }}>
                    <Image preview={false} src={logo} style={{ padding: "20%" }} />
                  </Col>
                </Row>
                <MainMenu
                  inlineCollapsed={collapse}
                  items={menuItems
                    .filter((m) => m.showInMenu)
                    .map(({ label, icon, target, exact, subMenu }) => ({
                      label,
                      icon,
                      path: target,
                      exact,
                      subMenu: subMenu && subMenu.filter((menu) => menu.showInMenu).map((menu: MenuItem) => createMainMenuItem(menu)),
                    }))}
                />
              </Sider>
              <Layout className="site-layout">
                <Header
                  className="header"
                  style={{
                    backgroundColor: "white",
                    padding: 0,
                    textAlign: "left",
                    height: "80px",
                  }}
                >
                  <Row>
                    <Col>
                      {React.createElement(collapse ? MenuUnfoldOutlined : MenuFoldOutlined, {
                        className: "trigger",
                        onClick: toggleCollapsed,
                      })}
                    </Col>

                    <Col
                      style={{
                        marginRight: 5,
                        alignItems: "center",
                        flex: 1,
                        textAlign: "right",
                      }}
                    >
                      <Space>
                        <Avatar size="large" icon={<UserOutlined />} />
                        <div>
                          <Col
                            span={24}
                            style={{
                              marginLeft: "15px",
                              marginRight: "15px",
                              height: "20px",
                              textAlign: "left",
                              fontSize: "16px",
                            }}
                          >
                            <span>{alias.name}</span>
                          </Col>
                          <Col
                            span={24}
                            style={{
                              marginRight: "15px",
                              marginLeft: "15px",
                              textAlign: "left",
                              fontSize: "12px",
                              color: "#979797",
                            }}
                          >
                            <span>{alias.group}</span>
                          </Col>
                        </div>
                      </Space>
                    </Col>
                    <Col style={{ marginRight: 20 }}>
                      <Dropdown overlay={menu}>
                        <a className="ant-dropdown-link" onClick={(e) => e.preventDefault()}>
                          <CaretDownOutlined />
                        </a>
                      </Dropdown>
                    </Col>
                  </Row>
                </Header>
                <Content
                  className="site-layout-background"
                  style={{
                    paddingBottom: 24,
                    paddingLeft: 24,
                    paddingRight: 24,
                    margin: "0px 16px",
                    minHeight: 280,
                  }}
                >
                  <MainRoute menuItems={[...menuItems]} />
                </Content>
                <Footer style={{ textAlign: "center", color: "rgba(0,0,0,.45)" }}>
                  <p>BAY D-Debt | Version: {appConfig.ddebtVersion}</p>
                  <p>Copyright ©2022 OSD</p>
                </Footer>
              </Layout>
            </Layout>
          </Router>
        </div>
      </Box>
    </>
  );
};
